<template>
	<main class="single page main margin-bottom-lg" :key="currentPageID">
		<SingleHeading v-if="!isProtected" />
		<ModuleBuilder  v-if="!isProtected" />
		<PasswordProtection v-else />
	</main>
</template>


<script>
import ModuleBuilder from '@/components/ModuleBuilder'
import PasswordProtection from '@/components/parts/PasswordProtection'
import SingleHeading from '@/components/parts/SingleHeading'

import { mapGetters } from 'vuex';

export default {
	name: 'single-page',
	components:{
		ModuleBuilder,
		PasswordProtection,
		SingleHeading,
	},
	computed: {
    ...mapGetters([
			'currentPage',
			'currentPageID',
    ]),
		isProtected(){
			let isProtected = false;
			if(this.currentPage && this.currentPage.is_protected === true){
				isProtected = true
			}
			return isProtected;
		},
	},
	mounted(){
	}
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.page{
	.module-builder{
		& > :first-child{
				margin-top: 50px;
				@include mquery($tablet){
						margin-top: 25px;
				}
				@include mquery($phone){
						margin-top: 20px;
				}
		}
	}
}
</style>